import React from 'react';
import styles from './FCSpinner.module.scss';
import classNames from 'classnames';

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';
const sizeMap: Record<SpinnerSize, number> = {
  sm: 15,
  md: 25,
  lg: 35,
  xl: 55,
};

interface FCSpinnerProps {
  size?: number | SpinnerSize;
  className?: string;
}

function FCSpinner({size = 'sm', className = ''}: FCSpinnerProps) {
  const sizeNumber = typeof size === 'string' ? sizeMap[size] : size;

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.spinner} style={{transform: `scale(${sizeNumber / 100})`}}>
        <div className={styles.blue} />
        <div className={styles.red} />
        <div className={styles.yellow} />
        <div className={styles.green} />
      </div>
    </div>
  );
}

export default FCSpinner;
